module.exports = __webpack_public_path__ + "static/media/addiconimages.d0cca2b8.svg";